import Branding from '../branding/branding';

export const AppImages = {
    [Branding.appBrandKeys.complexSolutions]: {
        logo: {
            'login': require('../branding/complex-solutions/logo-login.png'),
            'nav': require('../branding/complex-solutions/logo-app-nav.png'),
            'report-cover-page': require('../branding/complex-solutions/logo-report-cover-page.svg'),
            'report-footer': require('../branding/complex-solutions/logo-report-footer.svg'),
            'report-portal': require('../branding/complex-solutions/logo-report-footer.svg'),
            'bid-letter-header': require('../branding/complex-solutions/bid-letter-header.png'),
            'bid-letter-footer': require('../branding/complex-solutions/bid-letter-footer.png'),
        }
    },

    [Branding.appBrandKeys.appliedReserve]: {
        logo: {
            'login': require('../branding/applied-reserve-analysis/logo-login.png'),
            'nav': require('../branding/applied-reserve-analysis/logo-app-nav.png'),
            'report-cover-page': require('../branding/applied-reserve-analysis/logo-report-cover-page.png'),
            'report-footer': require('../branding/applied-reserve-analysis/logo-report-footer.png'),
            'report-portal': require('../branding/applied-reserve-analysis/logo-report-footer.png'),
            'bid-letter-header': require('../branding/applied-reserve-analysis/bid-letter-header.png'),
            'bid-letter-footer': require('../branding/applied-reserve-analysis/bid-letter-footer.png'),
        }
    }
};



// WEBPACK FOOTER //
// ./src/config/images.tsx